export default "__VITE_ASSET__aa55cf88__"